import { render, staticRenderFns } from "./SkupPrometForma.vue?vue&type=template&id=777b8c49&scoped=true&"
import script from "./SkupPrometForma.vue?vue&type=script&lang=js&"
export * from "./SkupPrometForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b8c49",
  null
  
)

export default component.exports